import { EBARRING_STATUS, IBarring } from "../interface/IBarrings";

export interface IBarringResponse {
    barringStatus?: EBARRING_STATUS;
    name: string;
    barringCode: string;
}

export interface IBarringListResponse {
    barrings: IBarringResponse[];
}

export const getResponseToState = (response: IBarringListResponse): IBarring[] =>
    response.barrings.map((barring) => ({
        barringStatus: barring.barringStatus,
        name: barring.name,
        barringCode: barring.barringCode,
    }));
